import { createUseStyles } from "react-jss";
import { colors } from "../../constants";

const useStyles = createUseStyles({
  row: { flex: 0.5 },
  primaryIcon: {
    color: "white",
    padding: "0.1rem 0.3rem",
    borderRadius: "50%",
    width: 35,
    height: 35,
    backgroundColor: colors.blue,
    margin: "auto",
    marginLeft: "0.3rem",
  },
  secondaryIcon: {
    padding: "0.1rem 0.3rem",
    borderRadius: "50%",
    width: 35,
    height: 35,
    backgroundColor: colors.gray,
    margin: "auto",
    marginLeft: "0.3rem",
  },
});

export default useStyles;
